import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { ProductContextProvider } from "vino/context";
import { AddToCart } from "vino/components";
import Image from "vino/components/Image";
import { FormattedAmount } from "vino/core";
import { settings } from "vino/settings";

const ProductListItem = (props) => {
	const { product } = props;
	const {
		variants: { nodes: variants },
	} = product;

	return (
		<>
			{variants.map((variant) => {
				const contextValue = {
					...product,
					variant,
				};
				return (
					<ProductContextProvider key={variant.id} product={contextValue}>
						<div className="col w-full list-view-item p-5">
							<div className="card w-full shadow-sm mb-5">
								<div className="prodPic">
									<Image image={product} />
								</div>
								<div className="card-body px-10">
									<span className="dark list-item-title">{product.name}</span>
									<p className="card-text min-h-10">{product.description}</p>

									<div className="flex justify-content-between qrp-wrap pb-10">
										<div className="qr-details">
											<span className="prod-quantity">{variant.name}</span>
											<span className="prod-price">
												<FormattedAmount value={variant.price} />
											</span>
										</div>

										<AddToCart />
									</div>
								</div>
							</div>
						</div>
					</ProductContextProvider>
				);
			})}
		</>
	);
};

ProductListItem.propTypes = {
	product: PropTypes.object.isRequired,
};

export default ProductListItem;
